const RENDERING_SERVICE = 'https://rendering.documents.cimpress.io';
const VORTEX_RASTER_SERVICE = 'https://raster.vortex.documents.cimpress.io/';
export function getPreviewUrl(args) {
    if (!Number.isInteger(args.dimensions.width) && !Number.isInteger(args.dimensions.height)) {
        throw Error('Rendering dimensions must be integers!');
    }
    if (args.quality && (!Number.isInteger(args.quality) || args.quality < 0 || args.quality > 100)) {
        throw Error('Rendering quality must be an integer between 0 and 100!');
    }
    if (args.view.type === 'panel') {
        return buildPanelRenderingUrl(args, args.view);
    }
    if (args.view.type === 'scene') {
        return buildSceneRenderingUrl(args, args.view);
    }
    if (args.view.type === 'vortex') {
        if (args.view.vortex.stage === undefined) {
            throw Error('Stage config required to preview a 3D model!');
        }
        return buildVortexRasterUrl(args, args.view);
    }
    throw Error('Unknown view type!');
}
export function validParams(accessToken, request) {
    if (!accessToken) {
        return {
            error: 'accessToken was not found, accessToken is required',
        };
    }
    if (!request) {
        return {
            error: 'request was not found, request is required',
        };
    }
    if (request && (!request.reference || !request.reference.attributes || !request.reference.id)) {
        return {
            error: 'request was found, but it is invalid. One of these is invalid (id, attributes)',
        };
    }
    return {
        success: true,
        error: null,
    };
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function buildPanelRenderingUrl(args, _view) {
    const params = new URLSearchParams();
    if (args.dimensions.width) {
        params.set('width', args.dimensions.width.toString());
    }
    if (args.dimensions.height) {
        params.set('height', args.dimensions.height.toString());
    }
    params.set('referrer', args.user.referrer);
    return `${RENDERING_SERVICE}/v1/${args.user.tenant.id}/preview?${params.toString()}`;
}
function buildSceneRenderingUrl(args, view) {
    const params = new URLSearchParams();
    if (args.dimensions.width) {
        params.set('width', args.dimensions.width.toString());
    }
    if (args.dimensions.height) {
        params.set('height', args.dimensions.height.toString());
    }
    params.set('referrer', args.user.referrer);
    if (args.format) {
        params.set('format', args.format);
    }
    if (args.quality) {
        params.set('quality', args.quality.toString());
    }
    if (args.bgColor) {
        params.set('bgColor', args.bgColor);
    }
    params.set('instructions_uri', args.instructionsUrl);
    params.set('scene', view.scene.url);
    return `${RENDERING_SERVICE}/v1/${args.user.tenant.id}/preview?${params.toString()}`;
}
function buildVortexRasterUrl(args, view) {
    var _a, _b;
    const params = new URLSearchParams();
    if (args.dimensions.width) {
        params.set('width', args.dimensions.width.toString());
    }
    if (args.dimensions.height) {
        params.set('height', args.dimensions.height.toString());
    }
    params.set('referrer', args.user.referrer);
    if (args.format) {
        params.set('format', args.format);
    }
    if (args.quality) {
        params.set('quality', args.quality.toString());
    }
    if (args.bgColor) {
        params.set('bgColor', args.bgColor);
    }
    params.set('renderingInstructionsUrl', args.instructionsUrl);
    params.set('productConfigUrl', view.vortex.model.url);
    params.set('stageConfigUrl', (_b = (_a = view.vortex.stage) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '');
    return `${VORTEX_RASTER_SERVICE}/app/raster?${params.toString()}`;
}
//# sourceMappingURL=helpers.js.map